// extracted by mini-css-extract-plugin
export default {"root":"TsComment_root__-rDfd","compact":"TsComment_compact__Jh+nB"};